import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import useHttp from '../../../hook/use-http';
import SingleRangeBuckets_Kratos from './SingleRangeBuckets_Kratos';
import SingleBoxRange_Kratos from './SingleBoxRange_Kratos';
import moment from 'moment';
import { ThreeCircles } from 'react-loader-spinner';

function TwoChartTemplate({ title, type, gloablfilter }) {
  return (
    <>
      <div className="chartbox">
        <div className="row">
          <div className="col-md-12">
            <div className="titlebg p-2">{title}</div>
          </div>
          {(type == "RANGE") ? (
            <>
              <SingleBoxRange_Kratos title={title} gloablfilter={gloablfilter} apiend="rangeboxchart" yaxis_title="Range" idStr="Range" />
              <SingleRangeBuckets_Kratos title={title} gloablfilter={gloablfilter} apiend="rangebarchart" yaxis_title="Vehicle Count" />
            </>
          ) :
            (<>
              <SingleBoxRange_Kratos title={title} gloablfilter={gloablfilter} apiend="energyboxchart" yaxis_title="Wh/km" idStr="Whkm" />
              <SingleRangeBuckets_Kratos title={title} gloablfilter={gloablfilter} apiend="energybarchart" yaxis_title="Vehicle Count" />
            </>
            )
          }
        </div>
      </div>
    </>
  );
}

export default TwoChartTemplate;